import { useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";

import { useGetCareersData } from "../../../../hooks/misc";
import { useGetStudentDetails } from "../../../../hooks/students";

import { StudentResumeTab } from "../../../../interfaces/student";

import StudentDetailsLayout from "../../../layouts/Student";

import BuilderView from "../../../sub_components/student/resume/BuilderView";

import { TabContainer } from "../../../sub_components/Tabs";
import ScannerView from "../../../sub_components/student/resume/scanner/ScannerView";

const StudentResumeDetails = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const { data: student, isLoading: isStudentLoading } = useGetStudentDetails(studentId);
    const { data: careersData, isLoading: careersLoading } = useGetCareersData(studentId);

    const builderData = careersData?.resume_builds || [];

    const tabItems = [
        { id: 'Builder', label: 'Builder' },
        { id: 'Scanner', label: 'Scanner' }
    ];

    const [currentTab, setCurrentTab] = useState<StudentResumeTab>('Builder');

    const resumeScans = careersData?.resume_scans ?? [];

    const tab = location.state?.tab ?? null;
    useEffect(() => {
        if (tab) setCurrentTab(tab);
    }, [tab]);

    useEffect(() => {
        const container = document.querySelector('.immersion__common_details__sub_info__forms_container');
        if (container) container.scrollTo(0, 0);
    }, [currentTab]);

    const handleTabChange = (tabId: string) => {
        setCurrentTab(tabId as StudentResumeTab);
    };

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Resume"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className='immersion__common_details__sub_info_view'>
                    <TabContainer
                        items={tabItems}
                        activeTab={currentTab}
                        onChange={handleTabChange}
                        variant="content"
                    />
                    <div className="immersion__common_details__sub_info__forms_container">
                        {currentTab === 'Builder' &&
                            <BuilderView
                                goBackRoute={location.state?.goBackRoute ?? null}
                                linked={true}
                                isLoading={isStudentLoading}
                                builderData={builderData}
                                setCurrentTab={setCurrentTab}
                            />
                        }
                        {currentTab === 'Scanner' &&
                            <ScannerView
                                goBackRoute={location.state?.goBackRoute ?? null}
                                linked={true}
                                isLoading={careersLoading}
                                resumeScans={resumeScans}
                            />
                        }
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    );
};

export default StudentResumeDetails;